// EventsSection.tsx
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./slider.css"; // <- renamed to match your convention
import { useEffect, useRef, useState } from "react";

const eventList = [
  {
    title: "Limited Committee Size",
    image: "", // No image needed in your screenshot
    description:
      "With each committee capped at just 70 delegates, OxfordMUN India ensures space for depth, dialogue, and meaningful diplomacy. This format isn’t just a number, it’s a philosophy. Fewer people in the room means more time to speak, more clarity in debate, and more growth for every individual.",
  },
  {
    title: "Attend OxfordMUN UK Conference",
    image: "",
    description:
      "Top-performing delegates at OxfordMUN India 2025 will earn a <b>100% scholarship on registration fee</b> to represent India at the <b>OxfordMUN Home Conference in the United Kingdom</b>. It’s a global stage, and a moment that can shape a lifetime.",
  },
  {
    title: "Personal Growth",
    image: "",
    description:
      "OxfordMUN India pushes you, not just to speak better, but to think deeper, listen harder, and understand wider. From the adrenaline of debate to the quiet moments in between, growth here is both personal and powerful.",
  },
  {
    title: "Oxford’s Legacy",
    image: "",
    description:
      "OxfordMUN India is built in collaboration with Oxford Global, carrying forward a legacy of academic seriousness, intellectual honesty, and global relevance. OxfordMUN India is an extension of one of the world’s most respected institutions, adapted for a new generation of changemakers.",
  },
  {
    title: "Networking Opportunity",
    image: "",
    description:
      "Whether it’s in committee, over coffee, or during the socials, OxfordMUN India brings together exceptional students, chairs, mentors, and educators from across the country. These are the people you’ll debate today and build with tomorrow.",
  },
];

export default function EventsSection({ handleToggle = () => {}, isMobile }) {
  const [currentSlide, setCurrentSlide] = useState(1);
  const totalSlides = eventList.length;
  const swiperRef = useRef(null);

  const navConfig = {
    prevEl: `.swiper-button-prev-${isMobile ? "mobile" : "desktop"}-events`,
    nextEl: `.swiper-button-next-${isMobile ? "mobile" : "desktop"}-events`,
  };

  // 🔁 When `isMobile` changes, re-bind swiper navigation
  useEffect(() => {
    if (swiperRef.current && swiperRef.current.params?.navigation) {
      const swiper = swiperRef.current;

      swiper.params.navigation.prevEl = navConfig.prevEl;
      swiper.params.navigation.nextEl = navConfig.nextEl;

      swiper.navigation.destroy();
      swiper.navigation.init();
      swiper.navigation.update();
    }
  }, [isMobile]);

  return (
    <section className="events-section">
      <div className="container">
        <h2 className="events-title">
          The Unique OxfordMUN India 2025 Experience
        </h2>
        {/* Custom Bottom Controls */}
        <div className="custom-bottom-nav-mobile">
          <div className="custom-arrow swiper-button-prev-mobile-events">
            &#8592;
          </div>
          <div className="slide-counter">
            {currentSlide} / {totalSlides}
          </div>
          <div className="custom-arrow swiper-button-next-mobile-events">
            &#8594;
          </div>
        </div>
        <div className="custom-swiper-wrapper">
          <Swiper
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            breakpoints={{
              // 1440: { slidesPerView: 4, spaceBetween: 40 },
              1024: { slidesPerView: 3, spaceBetween: 30 },
              900: { slidesPerView: 2, spaceBetween: 20 },
              768: { slidesPerView: 1, spaceBetween: 10 },
            }}
            modules={[Navigation, Autoplay, A11y]}
            // navigation
            navigation={navConfig}
            onInit={(swiper) => {
              swiper.params.navigation.prevEl = navConfig.prevEl;
              swiper.params.navigation.nextEl = navConfig.nextEl;
              swiper.navigation.init();
              swiper.navigation.update();
            }}
            onSlideChange={(swiper) => {
              setCurrentSlide(swiper.realIndex + 1);
            }}
            autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
            loop
          >
            {eventList.map((event, idx) => (
              <SwiperSlide key={idx}>
                <div className="event-card">
                  {event.image && (
                    <img
                      src={event.image}
                      alt={event.title}
                      className="event-image"
                    />
                  )}
                  <div className="event-text">
                    <h5 className="event-heading">{event.title}</h5>
                    <p className="event-description">{event.description}</p>
                  </div>
                  <div className="buttons-section">
                    <button className="primary-btn" onClick={handleToggle}>
                      REGISTER NOW
                    </button>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Bottom Controls */}
          <div className="custom-bottom-nav">
            <div className="custom-arrow swiper-button-prev-desktop-events">
              &#8592;
            </div>
            <div className="slide-counter">
              {currentSlide} / {totalSlides}
            </div>
            <div className="custom-arrow swiper-button-next-desktop-events">
              &#8594;
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
